import DataApi from './DataApi';

class GlobalSearchApi extends DataApi {
  constructor() {
    super('search');
  }

  search({ q, objects, limit, signal } = {}) {
    const params = new URLSearchParams();
    if (q != null) params.set('q', q);
    if (objects) params.set('objects', objects);
    if (limit != null) params.set('limit', String(limit));
    return this.fetchAll(params.toString(), { signal });
  }
}

class GlobalSearchSettingsApi extends DataApi {
  constructor() {
    super('objectconfig/globalsearch/settings');
  }

  fetchSettings() {
    return this.fetchAll();
  }

  saveBulk(objects) {
    return this.update({ objects });
  }

  saveObject(objectName, payload) {
    return this.update(payload, objectName);
  }
}

export { GlobalSearchSettingsApi };
export default GlobalSearchApi;
